import MwsColors = require('./colors');

import { colors } from "material-ui/styles";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import muiZIndex from "material-ui/styles/zIndex";

import diyLightRawTheme from './diyLightRawTheme';

const palette = diyLightRawTheme.palette;

const lightTheme = {
    zIndex: Object.assign({}, muiZIndex, {
        layer: 1000003,
        popover: 1000003, /* DHDIY-33426 the popover z-index should be higher than the top-bar z-index*/
        dialogOverlay: 1000001,
        dialog: 1000002
    }),
    checkbox: {
        checkedColor: palette.accent1Color
    },
    flatButton: {
        color: colors.transparent,
        textColor: palette.primary2Color,
        primaryTextColor: palette.accent1Color,
        secondaryTextColor: palette.primary3Color
    },
    floatingActionButton: {
        secondaryColor: palette.primary2Color
    },
    paper: {
      backgroundColor: palette.canvasColor
    },
    radioButton: {
        checkedColor: palette.accent1Color
    },
    raisedButton: {
        secondaryColor: palette.primary2Color,
        disabledColor: palette.accent2Color,
        disabledTextColor: colors.white
    },
    slider: {
        trackColorSelected: palette.primary3Color,
        selectionColor: palette.accent1Color,
        rippleColor: palette.accent1Color
    },
    snackbar: {
        backgroundColor: palette.primary2Color,
        actionColor: palette.accent3Color
    },
    toggle: {
        thumbOnColor: palette.accent1Color
    },
    toolbar: {
        backgroundColor: MwsColors.mwsGrey50,
        iconColor: MwsColors.mwsGrey800,
        separatorColor: palette.primary2Color,
        menuHoverColor: colors.white
    },
    tabs: {
        backgroundColor: palette.primary2Color
    },
    textField: {
        focusColor: palette.accent1Color
    }
};

export = getMuiTheme(diyLightRawTheme, lightTheme);



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/material-ui/diyLightTheme.ts
 **/